import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-down-arrow-primary",
  "use": "ic-down-arrow-primary-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic-down-arrow-primary\">\n    <path fill=\"#3D445A\" fill-rule=\"evenodd\" d=\"M8.276 9.333h7.448a.667.667 0 0 1 .471 1.138l-3.724 3.724a.667.667 0 0 1-.942 0l-3.724-3.724a.667.667 0 0 1 .471-1.138z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol